import { useGlobalContext } from '@/hooks/use-global-context';

import { routes } from '@/utils/route-utils';

export default function useLogoUrl(): string {
  return useGlobalContext()?.pageMeta.templateSetting?.logoUrl || routes.home();
}
